export const API_BASE_URL = "https://cms.sunbook.ca/api/api.php?action=";
